import { Component, Vue } from 'vue-property-decorator';
import { isFeatureEnabled } from '@/features/common/helpers/feature-flag';
import { featureNames } from '@/features/common/constants/features';

@Component
export default class FeatureFlagMixin extends Vue {
  public featureFlags: Record<string, boolean> = {};

  protected featureKeysToLoad: string[] = [];

  protected async loadFeatureFlag(key: string): Promise<boolean | undefined> {
    const featureName = featureNames[key];

    if (this.featureFlags[key] !== undefined) {
      return this.featureFlags[key];
    }

    const isEnabled = await isFeatureEnabled(featureName);
    this.$set(this.featureFlags, key, isEnabled);
    return isEnabled;
  }

  protected async loadFeatureFlags(keys: string[]): Promise<void> {
    const promises = keys.map(this.loadFeatureFlag);
    await Promise.all(promises);
  }

  async beforeMount(): Promise<void> {
    if (this.featureKeysToLoad.length > 0) {
      await this.loadFeatureFlags(this.featureKeysToLoad);
    }
  }
}
